import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../configure_store";
import { GetMenuProductListResponseModel } from "../../../services/menu_products/models/get_menu_product_list.response";

interface ProductState {
  productList: GetMenuProductListResponseModel[];
  selectedCategoryId: string;
}

const initialState: ProductState = {
  productList: [],
  selectedCategoryId: "",
};
const productSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setProductList: (
      state,
      action: PayloadAction<GetMenuProductListResponseModel[]>,
    ) => {
      state.productList = action.payload;
    },
    categoryIdChange: (state, action: PayloadAction<string>) => {
      state.selectedCategoryId = action.payload;
    },
  },
});

export const { setProductList, categoryIdChange } = productSlice.actions;

export const getProductList = (state: RootState) => state.product.productList;
export const getProductSelectedCategoryId = (state: RootState) =>
  state.product.selectedCategoryId;
const ProductReducer = productSlice.reducer;
export default ProductReducer;
